class GoalsIntroModal
  @init: () ->
    if localStorage.getItem('seen_introToGoalsPage') != 'true' && window.innerWidth >= 640
      if $('#focusModal01').length > 0
        $('#focusModal01').foundation('open')
        $('#focusModal01').on 'closed.zf.reveal', ->
          localStorage.setItem('seen_introToGoalsPage', 'true')

export default GoalsIntroModal
